<template>
  <div>
    <v-main>
      <div class="col-md-12 ml-sm-auto col-lg-12 px-4">
        <v-row>
        <v-col cols="12">
             <left-emp-menu></left-emp-menu>
        </v-col>
          <v-col>
          <v-card-title class="header_1">
              ประกันสุขภาพ
              <v-icon color="#871B12">mdi-account-circle-outline </v-icon>
              <v-spacer></v-spacer>
                <!-- <v-col
                class='text-right'>
                <v-btn color="primary" depressed @click="dialogAdd = true, validate('ADD')">
                  <v-icon left>mdi-text-box-plus</v-icon>
                  เพิ่มข้อมูล
                </v-btn>
                </v-col> -->
            </v-card-title>
            <v-divider color="#871B12"></v-divider>

            <!-- <v-dialog v-model="dialogAdd" persistent max-width="80%">
              <v-card>
                <v-card-title>
                  <span class="headline">เพิ่มข้อมูลประกันสังคม</span>
                </v-card-title>
                <v-card-text>
                  <v-container>
                  <v-form
                    ref="form_add"
                    v-model="valid_add"
                    lazy-validation
                  >
                    <v-row>
                        <v-col cols="12">
                        <v-autocomplete
                          v-model="formAdd.healthAddress"
                          label="สถานพยาบาล * "
                          :items="hospital_address"
                          :rules="nameRules"
                            required
                            dense
                            outlined
                        ></v-autocomplete>
                        </v-col>
                        <v-col cols="12" sm="6">
                        <v-text-field
                        v-model="formAdd.healthTel"
                        :rules="nameRules"
                        label="เบอร์โทรศัพท์ *"
                            required
                            dense
                            outlined
                        ></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6">
                        <v-text-field
                        v-model="formAdd.healthNumber"
                        :rules="nameRules"
                        label="เลขที่รับแจ้ง *"
                            required
                            dense
                            outlined
                        ></v-text-field>
                        </v-col>
                        <v-col cols="12" sm="6">
                        <v-menu
                          ref="menu7"
                          v-model="menu7"
                          :close-on-content-click="false"
                          :return-value.sync="date"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              v-model="formAdd.healthStartDate"
                              label="วันที่เริ่มใช้สิทธิ์ * "
                              :rules="nameRules"
                              prepend-icon="mdi-calendar"
                              :readonly="!rollHR"
                              dense
                              outlined
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="formAdd.healthStartDate"
                          :readonly='!rollHR'
                          no-title scrollable
                          locale="th-th">
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menu7 = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.menu7.save(formAdd.startDate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                          <v-menu
                            ref="menu8"
                            v-model="menu8"
                            :close-on-content-click="false"
                            :return-value.sync="date"
                            transition="scale-transition"
                            offset-y
                            min-width="auto"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-text-field
                                v-model="formAdd.healthExpireDate"
                                label="วันที่หมดอายุ * "
                                :rules="nameRules"
                                prepend-icon="mdi-calendar"
                                :readonly="!rollHR"
                                dense
                                outlined
                                v-bind="attrs"
                                v-on="on"
                              ></v-text-field>
                            </template>
                            <v-date-picker v-model="formAdd.healthExpireDate"
                            :readonly='!rollHR'
                            no-title scrollable
                            locale="th-th">
                              <v-spacer></v-spacer>
                              <v-btn
                                text
                                color="primary"
                                @click="menu8 = false"
                              >
                                Cancel
                              </v-btn>
                              <v-btn
                                text
                                color="primary"
                                @click="$refs.menu8.save(formAdd.endDate)"
                              >
                                OK
                              </v-btn>
                            </v-date-picker>
                          </v-menu>
                        </v-col>

                    </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    elevation="2"
                    x-large
                    color="dark darken-1"
                    text
                    @click="dialogAdd = false"
                  >
                    <v-icon left> mdi-cancel</v-icon>
                    ปิด
                  </v-btn>
                  <v-btn
                    elevation="2"
                    x-large
                    color="success"
                    text
                    :disabled="!valid_add"
                    @click="addData()"
                  >
                    <v-icon left>mdi-checkbox-marked-circle</v-icon>
                    เพิ่ม
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog> -->

            <v-card class="overflow-y-auto">
                <!-- <v-tab>
                  <v-icon left>
                     mdi-hospital-building
                  </v-icon>
                  ประกันสังคม
                </v-tab>
                <v-tab>
                  <v-icon left>
                     mdi-hospital-building
                  </v-icon>
                  ประกันกลุ่ม
                </v-tab> -->

                  <v-card flat>
                    <v-card-text>
                      <div v-for="(items, index) in dataHealth" :key="index">
                      <v-card elevation="2">
                            <v-card-text>
                              <v-card-title class="header_1">
                                ประกันสังคม
                                <v-spacer></v-spacer>
                              </v-card-title>
                            <v-form>
                            <v-container>
                            <v-row>
                                <v-col cols="12" sm="12">
                                <v-autocomplete
                                 v-model="items.healthAddress"
                                 :items="hospital_address"
                                 label="สถานพยาบาล *"
                                    required
                                    :readonly="!rollHR"
                                    :disabled="!rollHR"
                                    dense
                                    outlined
                                ></v-autocomplete>
                                </v-col>
                            </v-row>
                                <v-row>
                                <v-col cols="12" sm="6">
                                <v-text-field
                                v-model="items.healthTel"
                                label="เบอร์โทรศัพท์ *"
                                    required
                                    :readonly="!rollHR"
                                    :disabled="!rollHR"
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>

                                <v-col cols="12" sm="6">
                                <v-text-field
                                v-model="items.healthNumber"
                                label="เลขที่รับแจ้ง *"
                                    required
                                    :readonly="!rollHR"
                                    :disabled="!rollHR"
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>
                                </v-row>
                                <v-row>
                                <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu6"
                              v-model="menu6"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthStartDate"
                                  label="วันที่เริ่มใช้สิทธิ์ * "
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                              v-model="items.healthStartDate"
                              :readonly='!rollHR'
                              no-title scrollable
                              locale="th-th"
                              @input="menu6 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                         <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu5"
                              v-model="menu5"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthExpireDate"
                                  label="วันที่หมดอายุ * "
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="items.healthExpireDate" no-title scrollable
                              :readonly='!rollHR'
                              locale="th-th"
                              @input="menu5 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                                </v-row>
                              </v-container>
                            </v-form>
                          </v-card-text>
                          </v-card>
                      </div>
                    </v-card-text>
                  </v-card>

                  <v-card flat>
                    <v-card-text>
                      <div v-for="(items, index) in dataHealth" :key="index">
                        <v-card elevation="2">
                          <v-card-text>
                            <v-card-title class="header_1">
                                ประกันกลุ่ม
                                <v-spacer></v-spacer>
                              </v-card-title>
                            <v-form>
                            <v-container>
                                <v-row>
                                <v-col cols="12" sm="6">
                                <v-text-field
                                v-model="items.healthGroupNumber"
                                label="กรมธรรม์เลขที่ *"
                                    placeholder="GTL 00000-00000-000"
                                    required
                                    :readonly="!rollHR"
                                    :disabled="!rollHR"
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                <v-text-field
                                v-model="items.empHealthName"
                                label="บริษัท ประกัน *"
                                    required
                                    :readonly="!rollHR"
                                    :disabled="!rollHR"
                                    dense
                                    outlined
                                ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu"
                              v-model="menu"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthGroupStartDate"
                                  label="วันที่ แจ้งเข้า * "
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="items.healthGroupStartDate" no-title scrollable
                              :readonly='!rollHR'
                              locale="th-th"
                              @input="menu = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                         <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu2"
                              v-model="menu2"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthGroupRenew"
                                  label="เข้าระบบ / ต่ออายุ * "
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="items.healthGroupRenew" no-title scrollable
                              :readonly='!rollHR'
                              locale="th-th"
                              @input="menu2 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu3"
                              v-model="menu3"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthGroupStart"
                                  label="วันที่ เริ่มคุ้มครอง * "
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="items.healthGroupStart" no-title scrollable
                              :readonly='!rollHR'
                              locale="th-th"
                              @input="menu3 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                         <v-col cols="12" sm="6">
                            <v-menu
                              ref="menu4"
                              v-model="menu4"
                              :close-on-content-click="false"
                              :return-value.sync="date"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="items.healthGroupEnd"
                                  label="วันที่ สิ้นสุด คุ้มครอง*"
                                  :rules="nameRules"
                                  prepend-icon="mdi-calendar"
                                  :disabled="!rollHR"
                                  dense
                                  outlined
                                  v-bind="attrs"
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="items.healthGroupEnd" no-title scrollable
                              :readonly='!rollHR'
                              locale="th-th"
                              @input="menu4 = false"
                              >
                              </v-date-picker>
                            </v-menu>
                          </v-col>
                            </v-row>
                           <!-- <v-col v-if="rollHR" cols='12' class='text-right'>
                                  <v-btn
                                    color='success'
                                    class="mr-0"
                                    @click="editData(items)"
                                  >
                                    แก้ไขข้อมูล
                                  </v-btn>
                                </v-col> -->
                              </v-container>
                            </v-form>
                          </v-card-text>
                          </v-card>
                        </div>
                    </v-card-text>
                  </v-card>
            </v-card>

            <br>
            <br>
            <br>
            <v-row no-gutters>
              <v-footer fixed height="60px" color="#262A34">
                <v-col class='text-right'>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushBack"
                >
                <v-icon left> mdi-arrow-left-circle-outline</v-icon>
                  ย้อนกลับ
                </v-btn>
                <v-btn small
                  color="#E0E0E0"
                  @click="pushNext"
                >
                  หน้าถัดไป
                  <v-icon right> mdi-arrow-right-circle-outline</v-icon>
                </v-btn>
              </v-col>
              </v-footer>
            </v-row>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </div>
</template>
<script>
import axios from 'axios' // api
import EmpMenu from './EmployeeMenu.vue'
import hospitalName from '../../../assets/master/Hospital/hospitalName.json'

export default {
  components: {
    'left-emp-menu': EmpMenu
  },
  created () {
  },
  data () {
    return {
      rollHR: false,
      PK: '',
      path: '/employee_health/', // Path Model
      // Menu Config
      breadcrumbs: [],
      // End Menu Config
      dataReady: true,
      dateTime: '', // Generate DateTime
      date: new Date().toISOString().substr(0, 10),
      menu: false,
      menu2: false,
      menu3: false,
      menu4: false,
      menu5: false,
      menu6: false,
      dialogAdd: false,
      menu7: false,
      menu8: false,
      menu9: false,
      menu10: false,
      menu11: false,
      menu12: false,
      valid_add: true,
      valid_update: true,
      session: this.$session.getAll(),

      formAdd: {
        empCode: '',
        healthGroupNumber: '', // ประกันกลุ่มกรมธรรม์เลขที่
        healthGroupStartDate: '', // ประกันกลุ่มวันที่แจ้งเข้า
        healthGroupRenew: '', // ประกันกลุ่มเข้าระบบ-ต่ออายุ
        healthGroupStart: '', // ประกันกลุ่มวันที่เริ่มคุ้มครอง
        healthGroupEnd: '', // ประกันกลุ่มวันที่สิ้นสุด
        healthAddress: '', // ประกันสังคมสถานพยาบาล
        healthTel: '', // ประกันสังคมเบอร์โทรศัพท์
        healthNumber: '', // ประกันสังคมเลขที่รับแจ้ง
        healthStartDate: '', // ประกันสังคมวันที่เริ่มใช้สิทธิ์
        healthExpireDate: '', // ประกันสังคมวันที่หมดอายุ
        empHealthName: '' // ชื่อบริษัทประกัน
      },
      dataHealth: [],
      nameRules: [
        (v) => !!v || 'Input is required'
      ],
      json_meta: [
        [
          {
            key: 'charset',
            value: 'utf-8'
          }
        ]
      ],
      hospital_address: hospitalName,
      checkHideAdd: false,
      can: true
    }
  },
  async mounted () {
    this.dataReady = false
    await this.getGetTokenForEmployee()
    await this.checkEmpData()
  },
  methods: {
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    async checkEmpData () {
      this.can = localStorage.getItem('CanEdit')
      this.can = (this.can === 'true')
      if (localStorage.getItem('roll') === 'Employee') {
        this.dataEmp = JSON.parse(localStorage.getItem('data'))
      } else if (localStorage.getItem('roll') === 'HR') {
        this.rollHR = true
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      } else {
        this.dataEmp = JSON.parse(localStorage.getItem('dataByHR'))
      }
      if (localStorage.getItem('roll')) {
        await this.getDataById()
      }
    },
    async getDataById () {
      this.dataHealth = []
      await axios
        .get(
          // eslint-disable-next-line quotes
          this.DNS_IP + this.path + "getEmpCode?empCode=" + this.dataEmp.empCode,
          {
            headers: {
              'Application-Key': localStorage.getItem('ApplicationKey')
            }
          }
        )
        .then(async (response) => {
          this.dataReady = true
          if (response.data) {
            let rs = response.data
            if (rs.length < 1) {
              this.checkHideAdd = true
            }
            this.dataHealth = response.data
          }
        })
        // eslint-disable-next-line handle-callback-err
        .catch((error) => {
          this.dataReady = true
          console.log('error function getDataById : ', error)
        })
    },
    async editData (dt) {
      this.dataReady = false
      this.$swal({
        title: 'ต้องการ แก้ไขข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          let id = dt.empHealthID
          let ds = {
            healthGroupNumber: dt.healthGroupNumber,
            healthGroupStartDate: dt.healthGroupStartDate,
            healthGroupRenew: dt.healthGroupRenew,
            healthGroupStart: dt.healthGroupStart,
            healthGroupEnd: dt.healthGroupEnd,
            healthAddress: dt.healthAddress,
            healthTel: dt.healthTel,
            healthNumber: dt.healthNumber,
            healthStartDate: dt.healthStartDate,
            healthExpireDate: dt.healthExpireDate,
            empHealthName: dt.empHealthName
          }

          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "edit/" + id,
              ds,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              this.getDataById()
              this.$swal('เรียบร้อย', 'แก้ไขข้อมูล เรียบร้อย', 'success')
              this.dataReady = true
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.dataReady = true
              console.log('error function editDataGlobal : ', error)
            })
        })
        .catch((error) => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    pushNext () {
      this.$router.push(
        '/HRM/Employee/EmployeeCer?'
      )
    },
    pushBack () {
      this.$router.push(
        '/HRM/Employee/EmployeeExperience'
      )
    },
    async addData () {
      let databylogin = localStorage.getItem('data')
      //
      //
      // สำหรับ เพิ่มข้อมูล
      // ต้องระบุ Create / Last User ว่าใครเป็นคนสร้าง
      //
      this.formAdd.CREATE_USER = databylogin.userName
      this.formAdd.LAST_USER = databylogin.userName

      // // // // // // // // // // // // // // // // // // // // // // // // // // // // // //
      //
      // กำหนด Code ของรายการ * อย่าลืมเปลี่ยน field
      //
      this.formAdd.empCode = this.dataEmp.empCode

      this.dataReady = false
      this.$swal({
        title: 'ต้องการ เพิ่มข้อมูล ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async (result) => {
          delete this.formAdd['empHealthID']
          await axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP + this.path + "add",
              this.formAdd,
              {
                headers: {
                  'Application-Key': localStorage.getItem('ApplicationKey')
                }
              }
            )
            .then(async (response) => {
              // Debug response
              if (response.status === 200) {
                this.$swal('เรียบร้อย', 'เพิ่มข้อมูล เรียบร้อย', 'success')
                // Close Dialog
                this.dialogAddSS = false
                this.dialogAddHT = false
                this.dataReady = true
                this.clearData()
                this.getDataById()
              }
            })
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              console.log('error function addDataGlobal : ', error)
              this.dataReady = true
            })
        })
        .catch((error) => {
          console.log('error function addData : ', error)
          this.dataReady = true
        })
    },
    async clearData () {
      // eslint-disable-next-line no-redeclare
      for (var key in this.formAdd) {
        if (this.formAdd[key]) {
          this.formAdd[key] = ''
        }
      }
    }
  }
}
</script>
<style scope>
.scroll {
   overflow-y: scroll
}
.header_1 {
  font-family: Kanit;
  font-size: 20px;
  display: flex;

color: #871B12;
}
</style>



// WEBPACK FOOTER //
// src/components/HRM/Employee/EmployeeSso.vue